module.exports = __webpack_public_path__ + "img/0Q3B7497_Wood.25e19583.jpg";